export enum UserTypes {
  Dashpivot = 'dashpivot',
  Sitemate = 'sitemate',
}
